import CryptoJS, { enc } from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_CRYPTO_SECRET_KEY;

export const encryptData = (data, isUrl = false) => {
  let encryptedData = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    SECRET_KEY
  ).toString();

  if (isUrl) {
    encryptedData = encodeURIComponent(encryptedData);
  }
  return encryptedData;
};

export const decryptData = (encryptedData,isUrl = false) => {
  let decodedData = encryptedData;
  if (isUrl) {
    decodedData = decodeURIComponent(encryptedData);
  }

  const decryptedBytes = CryptoJS.AES.decrypt(
    decodedData?.replaceAll(" ", "+"),
    SECRET_KEY
  );
  const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
};
